import { styled } from '@mui/material/styles';
import { QTableHead } from '@kw/quokka-ui';
import { KwTableRow } from './KwTableRow';
import { KwTableCell } from './KwTableCell';

export const KwTableHead = styled(QTableHead)`
  ${KwTableRow} {
    background-color: #f5f5f5;
  }
  ${KwTableCell} {
    cursor: pointer;
    &:hover,
    &:hover > div,
    &:hover > div > img {
      background-color: #e0e0e0;
    }
  }
`;
